<h1 mat-dialog-title>
  <T str="Add as Involved"></T>
</h1>

<div mat-dialog-content>
  <form
    #tenantForm="ngForm"
    class="df c">
    <mat-form-field class="f1 amb">
      <mat-label>
        <T str="Tenant"></T>
      </mat-label>
      <input
        matInput
        type="text"
        name="tenantName"
        [value]="tenantName"
        disabled />
      <mat-icon matPrefix>person</mat-icon>
    </mat-form-field>

    <mat-form-field class="f1">
      <mat-label>
        <T str="Period"></T>
      </mat-label>
      <mat-date-range-input
        [rangePicker]="picker"
        required>
        <input
          matStartDate
          name="from"
          [(ngModel)]="modelRole.from"
          [placeholder]="'Start date' | translate"
          required />
        <input
          matEndDate
          name="to"
          [(ngModel)]="modelRole.to"
          [placeholder]="'End date' | translate" />
      </mat-date-range-input>
      <mat-datepicker-toggle
        matIconPrefix
        [for]="picker">
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </form>
</div>

<div
  mat-dialog-actions
  class="df">
  <button
    mat-button
    (click)="cancel()">
    <T str="Cancel"></T>
  </button>
  <button
    mat-raised-button
    (click)="save()"
    color="primary"
    [disabled]="!tenantForm.valid">
    <T str="Save"></T>
  </button>
</div>
